(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collage"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function () {
  $('.slider-collage').slick({
    dots: true,
    dotsClass:'custom-dots',
    arrows:false,
    infinite: true,
    speed: 500, 
    slidesToShow: 1, 
    slidesToScroll: 1,
    autoplay: false, 
    autoplaySpeed: 3000,
     focusOnSelect: true, 
    accessibility: true, 
  });
  
});
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-list"] && !Shopify.designMode) return;
  try {
    
    $('.vz-logo-bar').slick({
  dots: false,
  arrows:true,
  prevArrow:"<img src='https://cdn.shopify.com/s/files/1/0835/5378/0039/files/prev.svg?v=1725264234' style='cursor:pointer' width=30px>",
  nextArrow:"<img src='https://cdn.shopify.com/s/files/1/0835/5378/0039/files/next.svg?v=1725264233' style='cursor:pointer' width=30px>", 
  infinite: true,
  speed: 400,
  autoplay:true,
  autoplayspeed:600,
  slidesToShow: 7,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5,
        infinite: true,
        dots: false,
        arrows:true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }
  ]
});

  } catch(e) { console.error(e); }
})();
})();
